<template>
    <x-modal :title="title"
             :visible="showDialog"
             :loading="loading"
             @open="handleOpen"
             @close="clickClose"
             width="640px">
        <div class="row" v-loading="loading">
            <div class="col-md-6">
                <div :class="{'has-danger': errors.number}"
                     class="form-group">
                    <label class="control-label">Número <span class="text-danger">*</span></label>
                    <div>
                        <x-input-service v-model="form.number"
                                         :identity_document_type_id="form.identity_document_type_id"
                                         @search="searchNumber"></x-input-service>
                    </div>
                    <small v-if="errors.number"
                           class="form-control-feedback"
                           v-text="errors.number[0]"></small>
                </div>
            </div>
            <div class="col-md-6">
                <x-input v-model="form.name"
                         label="Nombre"></x-input>
            </div>
            <div class="col-md-6">
                <x-input v-model="form.address"
                         label="Dirección fiscal"></x-input>
            </div>
            <div class="col-md-6">
                <x-input v-model="form.number_mtc"
                         label="MTC"></x-input>
            </div>
            <div class="col-md-6">
                <x-switch-left v-model="form.is_default"
                               label="Predeterminado"></x-switch-left>
            </div>
            <div class="col-md-12 btn-actions">
                <x-button-cancel @click="clickClose"></x-button-cancel>
                <x-button-submit @click="onSubmit"></x-button-submit>
            </div>
        </div>
    </x-modal>
</template>

<script>

import {serviceNumber} from '@mixins/functions'
import XButtonSubmit from "../../../../components/Form/XButtonSubmit.vue";
import XInput from "../../../../components/Form/XInput.vue";
import XModal from "../../../../components/XModal.vue";
import XButtonCancel from "../../../../components/Form/XButtonCancel.vue";
import XSwitchLeft from "../../../../components/Form/XSwitchLeft.vue";

export default {
    name: 'DispatchDispatcherForm',
    components: {XSwitchLeft, XButtonCancel, XModal, XInput, XButtonSubmit},
    mixins: [serviceNumber],
    props: ['showDialog', 'recordId'],
    data() {
        return {
            loading: false,
            title: null,
            resource: 'dispatchers',
            errors: {},
            form: {},
        }
    },
    created() {
        this.initForm()
    },
    methods: {
        initForm() {
            this.errors = {}
            this.form = {
                id: null,
                identity_document_type_id: '6',
                number: '',
                name: null,
                address: null,
                number_mtc: null,
                is_default: false,
                is_active: true,
            }
        },
        async handleOpen() {
            this.title = (this.recordId) ? 'Editar Transportista' : 'Nuevo Transportista'
            if (this.recordId) {
                await this.$http.get(`/${this.resource}/record/${this.recordId}`)
                    .then(response => {
                        this.form = response.data.data
                    })
            }
        },
        async onSubmit() {
            this.loading = true
            await this.$http.post(`/${this.resource}`, this.form)
                .then(response => {
                    if (response.data.success) {
                        this.$message.success(response.data.message)
                        this.$emit('success', response.data.id)
                        this.clickClose()
                    } else {
                        this.$message.error(response.data.message)
                    }
                })
                .catch(error => {
                    if (error.response.status === 422) {
                        this.errors = error.response.data
                    } else {
                        console.log(error)
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },
        searchCustomer() {
            this.searchServiceNumberByType()
        },
        searchNumber(data) {
            this.form.name = (this.form.identity_document_type_id === '1') ? data.nombre_completo : data.nombre_o_razon_social;
            this.form.address = data.direccion_completa
        },
        clickClose() {
            this.$emit('update:showDialog', false)
        },
    }
}
</script>
